import { forwardRef, useEffect, useState } from "react";
import { CreateServiceTicketActiveScreen, updateCurrentScreen, closeOverlayAndReset, openOverlay } from "../redux/UIOverlayCreateServiceTicketRedux";
import { useAppDispatch, useAppSelector } from "../reduxhooks";
import { Box, createStyles, Dialog, Fade, Link, makeStyles, Slide } from "@material-ui/core";
import { UIOverlayViewStatus } from "common-ts/dist/models/UIOverlayViewStatus";
import { FlowComponentMaster } from "./OverlayViewCreateServiceTicketFlowBlocks";
import { TransitionProps } from "@material-ui/core/transitions";
import { Theme } from "@mui/material";
import { useHistory, useLocation } from "react-router-dom";
import { Order, OrderItem } from "common-ts/dist/models/Orders";
import { createServiceTicket } from "../redux/ServiceTicketRedux";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        titleLogoDesktopSignIn: {
            marginTop: "1.5vw",
            height: "5vw",
            [theme.breakpoints.only("xs")]: {
                marginTop: "3vw",
                height: "10vw",
            },
            cursor: "pointer",
        },
        titleLogoDesktop: {
            marginTop: "1.5vw",
            marginBottom: "1.5vw",
            height: "4vw",
            marginLeft: '7%',
            [theme.breakpoints.only("xs")]: {
                marginTop: "7vw",
                marginBottom: "3vw",
                height: "7vw",
            },
            cursor: "pointer",
        },
        contentBox: {
            width: "60%",
            margin: "auto",
            letterSpacing: "0.1px",
            [theme.breakpoints.only("xs")]: {
                width: "85%",
            },
        }
    })
);

const Transition = forwardRef(function Transition(props: TransitionProps & { children?: React.ReactElement<any, any> }, ref: React.Ref<unknown>) {
    return <Slide direction="up" ref={ref} {...props} timeout={170} />;
});

export default function OverlayView() {
    const dispatch = useAppDispatch();
    const classes = useStyles();
    const history = useHistory();
    const location = useLocation();
    const overlayView = useAppSelector((state) => state.overlayCreateServiceTicket);
    const isSignedIn = useAppSelector((state) => state.account.authState === "signedin");

    const [childrenVisible, setChildrenVisible] = useState<boolean>(true);
    const [selectedOrder, setSelectedOrder] = useState<Order | null>(null);
    const [selectedProducts, setSelectedProducts] = useState<OrderItem[]>([]);

    function delayedDispatch(currentScreen: CreateServiceTicketActiveScreen) {
        setChildrenVisible(false);
        setTimeout(() => {
            dispatch(updateCurrentScreen(currentScreen));
            setChildrenVisible(true);
        }, 1000);
    }

    function createServiceTicketDispatch(description: any[]) {
        dispatch(createServiceTicket(description));
    }

    useEffect(() => {
        if (location.pathname === '/service-ticket') {
            dispatch(openOverlay());
        }
    }, [dispatch, location.pathname]);

    function closeOverlay() {
        history.push("/shop");
        dispatch(closeOverlayAndReset());
    }

    let content: JSX.Element = FlowComponentMaster(
        {
            isSignedIn: isSignedIn,
        },
        {
            currentScreen: overlayView.currentScreen,
            selectedOrder: selectedOrder,
            selectedProducts: selectedProducts
        },
        {
            delayedDispatch: delayedDispatch,
            setSelectedOrder: setSelectedOrder,
            setSelectedProducts: setSelectedProducts,
            createServiceTicketDispatch: createServiceTicketDispatch
        }
    );

    return (
        <Box>
            <Box>
                <Link onClick={closeOverlay}>
                    {
                        overlayView.currentScreen === CreateServiceTicketActiveScreen.SignUpStart ? (
                            <img className={classes.titleLogoDesktopSignIn} src={"https://studiosclo.uk/legacy/CreateSizeOverlay_StudioSLogo.svg"} alt="maja logo" />
                        ) : (
                            <img className={classes.titleLogoDesktop} src={"https://studiosclo.uk/legacy/sur_monogram_minimum.svg"} alt="maja logo" />
                        )
                    }
                </Link>
            </Box>
            <Box className={classes.contentBox}>
                <Fade in={childrenVisible} timeout={400}>
                    {content}
                </Fade>
            </Box>
        </Box>
    );
}
